import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enrolled-courses"
export default class extends Controller {
  static targets = ["partialContainer"];

  switchPartial(event) {
    const lessonId = event.currentTarget.dataset.partial;
    const lessonUrl = `/students/lesson/${lessonId}`;
    const lessons = document.querySelectorAll('.course_lessons');
    const current_lesson = document.querySelector('#lesson_' + lessonId);

    fetch(lessonUrl)
      .then((response) => response.text())
      .then((html) => {
        window.scrollTo(0, 0);
        document.querySelector('#partialContainer').innerHTML = html;
        lessons.forEach(element => {
          element.classList.remove('text-white');
        });
        current_lesson.classList.add('text-white');       
        document.querySelector('#title').textContent = current_lesson.textContent
        //this.partialContainerTarget.innerHTML = html;
      });
  }
}
